/**
 * axios封装
 * 请求拦截、相应拦截、错误统一处理
 */
import Vue from 'vue'
import axios from 'axios'
// import QS from 'qs';
let CryptoJS = require('crypto-js')
import store from '@/store/index.js'
import router from '@/router'
import { decrypt } from './aes.js'
import { setCookie, getCookie } from './cookie.js'
axios.defaults.baseURL = process.env.VUE_APP_API_URL
// 设置请求时间（请求超时）
axios.defaults.timeout = 10000
// post请求头
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
// 响应拦截器
axios.interceptors.response.use(
  response => {
    if (response.status === 200) {
      // 登录接口成功后存token到cookie
      if (response.data.code == 0 || response.data.trace) {
        if (response.config.url.includes('/api/auth/login') && response.data.data.token) {
          setCookie('token', response.data.data.token)
        }
        return Promise.resolve(response)
      } else {
        return Promise.reject(response)
      }
    } else {
      return Promise.reject(response)
    }
  },
  // 服务器状态码不是200的情况
  error => {
    if (error && error.response && error.response.status) {
      switch (error.response.status) {
        // 401: 未登录
        // 未登录则跳转登录页面，并携带当前页面的路径
        // 在登录成功后返回当前页面，这一步需要在登录页操作。
        case 401:
          router.replace({
            path: '/login',
            query: { redirect: router.currentRoute.fullPath }
          })
          break
        // 403 token过期
        // 登录过期对用户进行提示
        // 清除本地token和清空vuex中token对象
        // 跳转登录页面
        case 403:
          Vue.prototype.$notice('登录过期，请重新登录')
          // 清除token
          store.commit('loginSuccess', null)
          // 跳转登录页面，并将要浏览的页面fullPath传过去，登录成功后跳转需要访问的页面
          setTimeout(() => {
            router.replace({
              path: '/login',
              query: {
                redirect: router.currentRoute.fullPath
              }
            })
          }, 1000)
          break
        // 404请求不存在
        case 404:
          Vue.prototype.$notice('网络请求不存在')
          break
        case 500:
          Vue.prototype.$notice('连接失败，请重试')
          break
        // 其他错误，直接抛出错误提示
        default:
      }
      return Promise.reject(error.response)
    } else if (error) {
      Vue.prototype.$notice(error.message)
    }
  }
)
/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function Get(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: params
      })
      .then(res => {
        if (!res.data) {
          reject(res)
        }
        console.warn('接口地址：', url)
        console.log('请求参数：', params)

        let resData = res.data.data
        if (res.data.encrypt === 1) {
          resData = decrypt(resData)
          console.log('返回数据（解密后）：', resData)
        } else {
          console.log('返回数据：', resData)
        }

        try {
          resolve(typeof resData === 'string' ? JSON.parse(resData) : resData)
        } catch (e) {
          resolve(resData)
        }
      })
      .catch(err => {
        reject(err.data)
      })
  })
}
export function GetJSON(url) {
  axios.defaults.baseURL = ''

  return new Promise((resolve, reject) => {
    axios
      .get(url)
      .then(res => {
        // res.data.data = decrypt(res.data.data)
        resolve(res.data)
      })
      .catch(err => {
        reject(err.data)
      })
  })
}
/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function Post(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .post(url, params, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(res => {
        if (res.data?.encrypt === 1) {
          let _data = decrypt(res.data.data)
          delete res.data.data
          res.data.data = JSON.parse(_data)
          console.warn('接口地址：', url)
          console.log('请求参数：', params)
          console.log('返回数据：', res.data.data)
          console.log('--------------------------------')
        }
        resolve(res.data)
      })
      .catch(err => {
        reject(err.data)
      })
  })
}
const AuthUrlList = ['/web/user/opt', '/api/user/getSms', '/web/api/auth/login']

// 请求拦截器
axios.interceptors.request.use(
  config => {
    if (config.method == 'post') {
      if (!AuthUrlList.includes(config.url) && !store.state.Credential) {
        return Promise.reject({ code: 900006 })
      }
      if (store.state.Credential) {
        // config.data = QS.stringify(setRequest(config.url, config.data))
        config.data = setRequest(config.url, config.data)
      }
    }
    // QS.stringify(params)
    // 每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token，不用每次请求都手动添加了
    // 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断
    // const token = store.state.token;
    // token && (config.headers.Authorization = token);
    // 从cookie读取token并加到headers
    const token = getCookie('token')
    if (!config.url.includes('/api/auth/login') && token) {
      config.headers.Authorization = `Bearer ${token}`
    }

    return config
  },
  error => {
    return Promise.error(error)
  }
)
const setRequest = function (url, param) {
  for (var key in param) {
    if (!param[key] && param[key] != 0) {
      delete param[key]
    }
  }

  if (!AuthUrlList.includes(url)) {
    if (!store.state.Telnum) {
      return Promise.reject({ code: 900006 })
    }
    // param.telnum = store.state.Telnum
  }
  let _param = param
  _param.t = new Date().valueOf()
  _param = sortParam(_param)
  if (store.state.Credential) {
    _param.credential = store.state.Credential
  }
  param.sign = CryptoJS.MD5(parseParam(_param)).toString()
  delete param.t
  delete param.credential
  delete param.sign
  return param
}

// 排序
const sortParam = function (param) {
  let newkey = Object.keys(param).sort()
  let newObj = {} //创建一个新的对象，用于存放排好序的键值对
  for (let i = 0; i < newkey.length; i++) {
    //遍历newkey数组
    newObj[newkey[i]] = param[newkey[i]]
    //向新创建的对象中按照排好的顺序依次增加键值对
  }
  return newObj
}
// 拼接sign
const parseParam = function (param) {
  let params = Object.keys(param)
    .map(function (key) {
      if (param[key] === null || param[key] === undefined) {
        param[key] = ''
      }
      return key + '=' + param[key]
    })
    .join('&')
  return params
}
